import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store';
import type { Event } from '@/types/residents/event';

export const selectHomeSlice = (state: RootState) => state.home;

export const selectEvents = createSelector([selectHomeSlice], (home) => home.events);

export const selectSortedEvents = createSelector([selectEvents], (events: Event[]) => {
  return events
    .slice()
    .sort((a: Event, b: Event) => {
      const aKey = a.startTimeLocal || a.startTime;
      const bKey = b.startTimeLocal || b.startTime;
      const da = aKey ? new Date(aKey).getTime() : 0;
      const db = bKey ? new Date(bKey).getTime() : 0;
      // DESC by start
      return db - da;
    });
});


